import React, { FC, useMemo } from "react";
import { Field, FormRenderProps } from "react-final-form";
import { Grid, makeStyles } from "@material-ui/core";
import BootstrapInput from "../../../../components/BootstrapInput";
import { getData } from "country-list";
import Autocomplete from "../../../../components/Autocomplete";

const useStyles = makeStyles(() => ({
  mainContainer: ({ makeTaller }: { makeTaller: boolean }) => ({
    width: "100%",
    height: makeTaller ? 254 : 185,
  }),
}));

const BranchForm: FC<FormRenderProps> = ({ handleSubmit, initialValues }) => {
  const showCountryField = !!initialValues.country;
  const classes = useStyles({ makeTaller: showCountryField });

  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <Grid container spacing={2}>
          {showCountryField && (
            <Grid item xs={12} sm={12} md={6}>
              <Field
                required
                fullWidth
                label="Country"
                options={countries}
                placeholder="Country"
                component={Autocomplete}
                name={"country"}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={6}>
            <Field
              fullWidth
              type="text"
              label="State"
              placeholder="State"
              component={BootstrapInput}
              parse={(value) => (value === "" || value === null ? "" : value)}
              name={"state"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Field
              required
              fullWidth
              type="text"
              label="City"
              placeholder="City"
              component={BootstrapInput}
              name={"city"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Field
              required
              fullWidth
              type="text"
              label="Address"
              placeholder="Address"
              component={BootstrapInput}
              name={"address"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Field
              required
              fullWidth
              type="text"
              label="Zip"
              placeholder="Zip"
              component={BootstrapInput}
              name={"zip"}
            />
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

export default BranchForm;
